import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { UsersReducerHandlers, GeneralReducerHandlers } from './handlers';
import { UsersActionTypes, GeneralActionTypes } from '../actions/types';

const usersReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...UsersReducerHandlers.fetchMoreUsers,
    ...UsersReducerHandlers.searchUsers,
    ...UsersReducerHandlers.fetchDataToCreateProject,
    ...UsersReducerHandlers.fetchDataToEditProject,
    ...UsersReducerHandlers.editProjectWithRelatedData,
    ...UsersReducerHandlers.deleteUser,
    ...UsersReducerHandlers.getUserById,
    ...UsersReducerHandlers.sendReinvite,
    ...UsersReducerHandlers.getUsers,
    ...UsersReducerHandlers.getUsersForExcel,
    ...UsersReducerHandlers.updateUser,
    ...UsersReducerHandlers.addUser,
    ...UsersReducerHandlers.fetchProjectOverviewDataByProjectId,
    ...UsersReducerHandlers.fetchProjectOverviewDataByCustomerId,
    [UsersActionTypes.resetUser]: (state, action) => ({ ...state, error: null }),
    ...UsersReducerHandlers.getWritersMatch,
    ...UsersReducerHandlers.getOfflineWritersMatch,
    ...UsersReducerHandlers.addWriterToShortlist,
    ...UsersReducerHandlers.removeWriterFromShortlist,
    ...UsersReducerHandlers.getUserWithMiscData,
    ...UsersReducerHandlers.fetchQuestionnaireByCustomerId,
    ...UsersReducerHandlers.getInterviewsInfo,
    ...UsersReducerHandlers.toggleArchivingUser,
    ...UsersReducerHandlers.removeAvatar,
    ...UsersReducerHandlers.fetchTimelineDataByCustomer,
    ...UsersReducerHandlers.getBookAndResourcesByProjectId,
    ...UsersReducerHandlers.getBookAndResourcesByCustomerId,
    ...UsersReducerHandlers.addAvatarPhoto,
    ...UsersReducerHandlers.getExcelWritersMatch,
    ...UsersReducerHandlers.getExcelOfflineWritersMatch,
    ...UsersReducerHandlers.removeUnsavedUserAvatar,
    ...UsersReducerHandlers.getDataFromHubspot,
    ...UsersReducerHandlers.getUserByToken,
    ...UsersReducerHandlers.updateHubspotProjectsCount,
    ...UsersReducerHandlers.updateWritersProjectCount,
    ...UsersReducerHandlers.updateWritersDBSScreened,
  },
);

export default usersReducer;
